"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_OPTIONS = void 0;
exports.formatCards = formatCards;
exports.formatStatus = formatStatus;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * 状态选项
 */
var STATUS_OPTIONS = exports.STATUS_OPTIONS = [{
  label: '启用',
  value: 1
}, {
  label: '禁用',
  value: 0
}];

/**
 * 格式化状态
 * @param {Object} row 行数据
 * @returns {string} 格式化后的状态文本
 */
function formatStatus(row) {
  var status = _typeof(row) === 'object' ? row.status : row;
  var intStatus = typeof status === 'string' ? parseInt(status) : status;
  return intStatus === 1 ? '启用' : '禁用';
}

/**
 * 格式化包含的卡片列表
 * @param {Array} cards 卡片列表
 * @returns {string} 格式化后的卡片文本
 */
function formatCards(cards) {
  if (!cards || !cards.length) return '--';
  return cards.map(function (card) {
    return "".concat(card.id, "-").concat(card.name);
  }).join(', ');
}